import { isAndroid } from '@/infrastructure/product-info';
import {
  FieldTyp,
  renderField,
  renderCharacterInputValue,
} from '@/presentation/components/compare/list';
import { CHARACTER_MATCH_OPTIONS, VERSION_MATCH_OPTIONS } from '@/presentation/components/form/standards/types';
import { FieldKey, getLocalField, getLocalFieldLabelByValue, StandardCommonFieldKey } from '@/proto/field';
import { MetricType } from '@/proto/metric';

export const getColumn = (metricType: MetricType) => (
  [
    { title: '时间范围', dataIndex: FieldKey.TimeRange },
    { title: 'APP版本', dataIndex: FieldKey.AppVersion, render: renderCharacterInputValue },
    { title: '系统版本', dataIndex: FieldKey.OsVersion, render: renderCharacterInputValue },
    { title: 'SDK版本', dataIndex: FieldKey.SdkVersion },
    { title: '机型', dataIndex: FieldKey.Model, disabled: metricType !== MetricType.TYPE_MEMORY },
    { title: '进程', dataIndex: FieldKey.ProcessName, disabled: !isAndroid() },
    { title: '32/64位1', dataIndex: FieldKey.Bit, disabled: metricType !== MetricType.TYPE_MEMORY || !isAndroid(), render: (value: string) => getLocalFieldLabelByValue(FieldKey.Bit, value) },
    { title: 'FD类型', dataIndex: FieldKey.FdType, disabled: metricType !== MetricType.TYPE_FD_LEAK, render: (value: string) => getLocalFieldLabelByValue(FieldKey.FdType, value) },
  ]
);

export const newColumn = (metricType: MetricType) => (
  [
    { title: '时间范围', dataIndex: FieldKey.TimeRange },
    { title: 'APP版本', dataIndex: StandardCommonFieldKey.AppVersion, render: (tex: FieldTyp) => renderField(tex, VERSION_MATCH_OPTIONS) },
    { title: '系统版本', dataIndex: StandardCommonFieldKey.OsVersion, render: (tex: FieldTyp) => renderField(tex, VERSION_MATCH_OPTIONS) },
    { title: 'SDK版本', dataIndex: StandardCommonFieldKey.SdkVersion, render: (tex: FieldTyp) => renderField(tex, VERSION_MATCH_OPTIONS) },
    { title: '机型', dataIndex: StandardCommonFieldKey.Model, render: (tex: FieldTyp) => renderField(tex, CHARACTER_MATCH_OPTIONS), disabled: metricType !== MetricType.TYPE_MEMORY },
    { title: '进程', dataIndex: StandardCommonFieldKey.ProcessName, render: (tex: FieldTyp) => renderField(tex, CHARACTER_MATCH_OPTIONS), disabled: !isAndroid() },
    { title: '32/64位', dataIndex: 'standard_is64bit', disabled: metricType !== MetricType.TYPE_MEMORY || !isAndroid(), render: (value: any) => {
      if (Array.isArray(value)) {
        return value?.map(str => getLocalField(FieldKey.Bit)?.find(item => item.value === str)?.label)?.join?.(',');
      }
      return getLocalField(FieldKey.Bit)?.find(item => item.value === value?.values)?.label || '所有';
    } },
    { title: 'FD类型', dataIndex: FieldKey.FdType, disabled: metricType !== MetricType.TYPE_FD_LEAK, render: (value: any) => getLocalField(FieldKey.FdType)?.find(item => item.value === value?.values)?.label || '所有' },
  ]
);
